import TriviaDetails from "./TriviaDetails";
export default TriviaDetails;
